"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FolderIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var FolderIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", d: "M5.33333333,5 L8.44444444,5 C8.86412084,5 9.25930527,5.20077917 9.51111111,5.54193548 L10.0444444,6.26451613 C10.2962503,6.60567244 10.6914347,6.80645161 11.1111111,6.80645161 L18.6666667,6.80645161 C19.4030463,6.80645161 20,7.41303356 20,8.16129032 L20,17.6451613 C20,18.393418 19.4030463,19 18.6666667,19 L5.33333333,19 C4.59695367,19 4,18.393418 4,17.6451613 L4,6.35483871 C4,5.60658195 4.59695367,5 5.33333333,5 Z" }))); };
exports.FolderIcon = FolderIcon;
